<template>
  <div>
    <b-card>
      <b-row class="d-flex justify-content-center align-items-end">
        <div class="m-5 d-flex flex-column justify-content-center align-items-center w-25">
          <b-img
            fluid
            thumbnail
            :src="classTeacherForm"
          />
          <p class="mt-1">
            {{ $t('Classroom Teacher Evaluation Form') }}
          </p>
          <div class="mt-3">
            <b-button
              :href="classTeacherFormPdf"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="printLabel('Classroom Teacher Evaluation Form')"
              variant="primary"
              class="ml-1"
            >
              <feather-icon
                icon="PrinterIcon"
                size="15"
              />
            </b-button>
          </div>
        </div>
        <div class="m-5 d-flex flex-column justify-content-center align-items-center w-25">
          <b-img
            fluid
            thumbnail
            :src="clientForm"
          />
          <p class="mt-1">
            {{ $t('Client Application Form') }}
          </p>
          <div class="mt-3">
            <b-button
              :href="clientFormPdf"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="printLabel('Client Application Form')"
              variant="primary"
              class="ml-1"
            >
              <feather-icon
                icon="PrinterIcon"
                size="15"
              />
            </b-button>
          </div>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BButton, BCard, BImg, BRow,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

const classTeacherForm = require('@/assets/images/forms/classroomteacherform2.jpg')
const classTeacherFormPdf = require('@/assets/images/forms/classroomteacherform.pdf')
const clientForm = require('@/assets/images/forms/clientapplicationform.jpg')
const clientFormPdf = require('@/assets/images/forms/clientapplicationform.pdf')

export default {
  components: {
    BButton,
    BCard,
    FeatherIcon,
    BImg,
    BRow,
  },
  data() {
    return {
      classTeacherForm,
      classTeacherFormPdf,
      clientForm,
      clientFormPdf,
    }
  },
  methods: {
    printLabel(formTitle) {
      return `${this.$t('Print')}: ${this.$t(formTitle)}`
    },
  },
}
</script>
